import axios from 'axios'

const getPartners = async (onlyActive = false) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/commission/partners`, {
    params: onlyActive ? { active: 1 } : undefined
  })
  return data
}

const createPartner = async (name, percent, active = true, commissionType = 'percent') => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/commission/partners`, {
    name,
    percent,
    active,
    commissionType
  })
  return data
}

const updatePartner = async (id, name, percent, active, commissionType = 'percent') => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/commission/partners/${id}`, {
    name,
    percent,
    active,
    commissionType
  })
  return data
}

const getReport = async (partnerId, iniDate, endDate) => {
  const { data } = await axios.get(
    `${process.env.VUE_APP_API}/commission/report/${partnerId}/${iniDate}/${endDate}`
  )
  return data
}

export {
  getPartners,
  createPartner,
  updatePartner,
  getReport
}
